import type { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../components/Button';

import { StyledChatRenderErrorFallback, StyledChatRenderErrorText } from './styles';

type AIOutreachChatRenderErrorFallbackProps = {
  resetErrorBoundary: () => void;
};

export const AIOutreachChatRenderErrorFallback = ({ resetErrorBoundary }: AIOutreachChatRenderErrorFallbackProps) => {
  const { t } = useTranslation();

  return (
    <StyledChatRenderErrorFallback data-automation="AIOutreachRenderError">
      <StyledChatRenderErrorText>
        {String(
          t(
            'company.overview.ai-outreach.render_error',
            'Something went wrong while showing the chat. You can try again.'
          )
        )}
      </StyledChatRenderErrorText>
      <Button variant="primary" onClick={resetErrorBoundary} data-automation="AIOutreachRenderErrorRetry">
        {String(t('company.overview.ai-outreach.try_again', 'Try again'))}
      </Button>
    </StyledChatRenderErrorFallback>
  );
};

export const AIOutreachChatErrorBoundaryFallback = ({ resetErrorBoundary }: FallbackProps) => (
  <AIOutreachChatRenderErrorFallback resetErrorBoundary={resetErrorBoundary} />
);
